<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Purchase Order</h4>
                        <h6 class="card-subtitle">Please keep your profile information always current in order to help you when you contact us.</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body card-blue">
                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="partner">Select Partner</label>
                                <div class="col-sm-9">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('partner')}"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :loading="isLoading"
                                            :max-height="600"
                                            :options="partners"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchSellers"
                                            class="form-control"
                                            data-vv-as="partner"
                                            id="partner"
                                            label="partner"
                                            name="partner"
                                            open-direction="bottom"
                                            placeholder="Search Partners"
                                            track-by="id"
                                            v-model="po.partner"
                                            v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.biz_name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.biz_name }}</h5>
                                                    <h6>{{ props.option.line1}}</h6>
                                                    <h6>{{ props.option.city+', '+ props.option.country}}</h6>
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="afterList">
                                            <div class="col-xs-12">
                                                <router-link :to="{name: 'addseller'}" class="btn btn-block btn-lg btn-outline-success">
                                                    <i class="fa fa-plus-circle"></i>&nbsp;Add Customer
                                                </router-link>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('partner')">{{ errors.first('partner') }}</div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="contract">Select Contract</label>
                                <div class="col-sm-5">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('contract')}"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :loading="isLoading"
                                            :max-height="600"
                                            :options="contracts"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchContracts"
                                            class="form-control"
                                            data-vv-as="contract"
                                            id="contract"
                                            label="contract"
                                            @input="setContract"
                                            name="contract"
                                            open-direction="bottom"
                                            placeholder="Search Contract"
                                            track-by="id"
                                            v-model="contract"
                                            v-validate="">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.contract_number }} - {{props.option.type}} - {{ props.option.counterparty.name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.contract_number }}</h5>
                                                    <h5>{{ props.option.type }}</h5>
                                                    <h5>{{ props.option.counterparty.name }}</h5>
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="afterList">
                                            <div class="col-xs-12">
                                                <router-link :to="{name: 'newcontractstep1'}" class="btn btn-block btn-lg btn-outline-success">
                                                    <i class="fa fa-plus-circle"></i>&nbsp;Add Contract
                                                </router-link>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('partner')">{{ errors.first('partner') }}</div>
                                </div>
                                <div class="col-sm-1 text-center p-t-10 col-form-label"> OR</div>
                                <div class="col-sm-3">
                                    <input type="text"
                                           class="form-control"
                                           @change="setContractNo"
                                           v-model="po.contract_number"
                                           name="contract_number"
                                           placeholder="Add Contract Number"
                                           style="height: 42px;">
                                </div>
                            </div>

                            <div class="form-group row" v-for="(row, index) in po.rows">
                                <label :for="'commodity_id'+index" class="col-sm-2 text-right control-label col-form-label">Good/Service</label>
                                <!-- Good/Service -->
                                <div class="col-sm-3">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('goodsservice'+index)}"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :internal-search="false"
                                                 :limit="3"
                                                 :loading="isLoading"
                                                 :max-height="600"
                                                 :options="goods"
                                                 :options-limit="300"
                                                 :searchable="true"
                                                 :show-no-results="false"
                                                 @input="setUnit(row)"
                                                 @search-change="getGoodsServices"
                                                 class="form-control"
                                                 data-vv-as="goodsservice"
                                                 id="goodsservice"
                                                 label="goodsservice"
                                                 :name="'goodsservice'+index"
                                                 open-direction="bottom"
                                                 placeholder="Search Goods/Service"
                                                 selectLabel=""
                                                 track-by="id"
                                                 v-model="row.good"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                    {{ props.option.name }} - {{ props.option.variety }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.name }}</h5>
                                                    {{ props.option.variety}}
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('goodsservice'+index)">{{ errors.first('goodsservice'+index) }}</div>
                                </div>
                                <!-- Quantity -->
                                <div class="col-sm-2 p-l-0 p-r-0">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}" :id="'quantity'+index"
                                               :name="'quantity'+index"
                                               class="form-control"
                                               data-vv-as="quantity"
                                               placeholder="Quantity"
                                               style="height: 42px; width: calc(100% - 70px)"
                                               step="any"
                                               type="number"
                                               v-model="row.quantity"
                                               v-validate="'required'">
                                        <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                                               class="form-control" disabled
                                               :value="row.unit.symbol">
                                    </div>
                                    <div class="invalid-feedback" style="display: block" v-if="submitted && errors.has('quantity'+index)">{{ errors.first('quantity'+index) }}</div>
                                </div>
                                <!-- Rate -->
                                <div class="col-sm-2 p-r-0">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                                               class="form-control" disabled
                                               :value="currency">
                                        <input :class="{'is-invalid': submitted && errors.has('rate'+index)}" :id="'rate'+index"
                                               :name="'rate'+index"
                                               class="form-control"
                                               data-vv-as="rate"
                                               placeholder="Rate"
                                               style="height: 42px; width: calc(100% - 50px)"
                                               type="number"
                                               step="any"
                                               v-model="row.rate"
                                               v-validate="'required'">
                                    </div>
                                    <div class="invalid-feedback" style="display: block" v-if="submitted && errors.has('rate'+index)">{{ errors.first('rate'+index) }}</div>
                                </div>
                                <!-- Tax -->
                                <div class="col-sm-2">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('tax'+index)}" :id="'tax'+index"
                                               :name="'tax'+index"
                                               class="form-control"
                                               data-vv-as="tax"
                                               placeholder="Tax"
                                               style="height: 42px; width: calc(100% - 50px)"
                                               type="number"
                                               step="any"
                                               v-model="row.tax"
                                               v-validate="'min_value:0'">
                                        <input :class="{'is-invalid': submitted && errors.has('tax'+index)}"
                                               class="form-control" disabled
                                               value="%">
                                    </div>
                                    <div class="invalid-feedback" style="display: block" v-if="submitted && errors.has('tax'+index)">{{ errors.first('tax'+index) }}</div>
                                </div>

                                <div class="col-sm-1">
                                    <div class="form-group btn-group">
                                        <button @click="addRow()" class="btn btn-outline-success" style="height: 40px" type="button" v-if="index === po.rows.length - 1">
                                            <i class="fa fa-cart-plus"/>
                                        </button>
                                        <button @click="removeRow(index)" class="btn btn-outline-danger" style="height: 40px" type="button" v-if="po.rows.length> 1">
                                            <i class="fa fa-trash-alt"/>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="audit">Discount</label>
                                <div class="col-sm-9">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('discount')}"
                                               class="form-control" disabled
                                               :value="currency">
                                        <input :class="{'is-invalid': submitted && errors.has('discount')}" id="discount"
                                               name="discount"
                                               class="form-control"
                                               data-vv-as="discount"
                                               placeholder="Discount"
                                               style="height: 42px; width: calc(100% - 50px)"
                                               type="number"
                                               v-model="po.discount"
                                               v-validate="'min_value:0'">
                                    </div>
                                    <div class="invalid-feedback" style="display: block" v-if="submitted && errors.has('discount')">{{ errors.first('discount') }}</div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="audit">Audit Url</label>
                                <div class="col-sm-9">
                                    <input :class="{'is-invalid': submitted && errors.has('audit')}" id="audit"
                                           name="audit"
                                           class="form-control"
                                           data-vv-as="audit"
                                           placeholder="Audit URL"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="po.audit"
                                           v-validate="'url'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('audit')">{{ errors.first('audit') }}</div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="comments">Comments</label>
                                <div class="col-sm-9">
                                    <textarea id="comments"
                                              name="comments"
                                              placeholder="Comments"
                                              class="form-control"
                                              rows="4"
                                              v-model="po.comments"/>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import UnitSelect from "../../common/UnitSelect";
    import Multiselect from 'vue-multiselect';
    import CurrencySelect from "../../../protected/common/CurrencySelect";

    export default {
        name: "PurchaseOrder",
        components: {UnitSelect, Multiselect, CurrencySelect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                isLoading: false,
                submitted: false,
                expressid: null,
                currency: null,
                partners: [],
                goods: [],
                contracts: [],
                contract: null,
                po: {
                    partner: null,
                    express_id: null,
                    currency_id: null,
                    audit: null,
                    contract_number: null,
                    contract_id: null,
                    comments: null,
                    discount: null,
                    rows: [
                        {
                            good: null,
                            quantity: null,
                            unit: {},
                            rate: null,
                            tax: null
                        }
                    ]
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                this.expressid      = this.currentOrg.express_id;
                this.po.express_id  = this.currentOrg.express_id;
                this.currency       = this.currentOrg.currency_symbol;
                this.po.currency_id = this.currentOrg.currency_id;
            },
            async getGoodsServices(searchText) {
                this.isLoading = true;
                let reply      = await this.$http.get("/express/" + this.expressid + "/purchases/goodsservices/search", {
                    params: {
                        search: searchText,
                        excludeOld: true
                    }
                });
                this.goods     = reply.data;
                this.isLoading = false;
            },
            async searchSellers(searchText) {
                try {
                    this.isLoading = true;
                    let reply      = await this.$http.get("/express/" + this.currentOrg.express_id + "/purchases/sellers/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners  = reply.data;
                    this.isLoading = false;
                } catch(e) {
                    console.log(e);
                }
            },
            async searchContracts(searchText) {
                try {
                    this.isLoading = true;
                    let reply      = await this.$http.get("/express/" + this.currentOrg.express_id + "/contracts", {
                        params: {
                            number: searchText
                        }
                    });
                    this.contracts = reply.data.contracts;
                    this.isLoading = false;
                } catch(e) {
                    console.log(e);
                }
            },
            setUnit(row) {
                if(row) {
                    row.unit = row.good.unit;
                }
            },
            setCurrency(e) {
                if(e) {
                    this.po.currency = {
                        id: e.id,
                        name: e.name,
                        symbol: e.symbol
                    }
                }
            },
            addRow() {
                this.po.rows.push({
                    good: null,
                    quantity: null,
                    unit: {},
                    rate: null
                });
            },
            async removeRow(index) {
                this.po.rows.splice(index, 1);
                this.submitted = false;
            },
            async save() {
                try {
                    $(".preloader").fadeIn();
                    let po = {
                        express_id: this.po.express_id,
                        seller_id: this.po.partner.partner_id,
                        currency_id: this.po.currency_id,
                        audit: this.po.audit,
                        contract_number: this.contract ? this.contract.contract_number : this.po.contract_number,
                        contract_id: this.contract ? this.contract.id : null,
                        comments: this.po.comments,
                        attachments: [],
                        discount: this.po.discount ? Number(this.po.discount) : 0,
                        goods: []
                    }

                    this.po.rows.forEach(row => {
                        po.goods.push({
                            good_id: row.good.id,
                            quantity: Number(row.quantity),
                            unit_id: row.unit.id,
                            rate: Number(row.rate),
                            tax: row.tax ? Number(row.tax) : 0
                        })
                    });

                    let reply = await this.$http.put(`/express/${this.currentOrg.express_id}/purchases`, po);
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'New Purchase order has been added successfully.', 'Purchase order Added');
                    this.$router.push({name: "expresspurchases"});
                } catch(e) {
                    console.error(e);
                    $(".preloader").fadeOut();
                }
            },
            handleSubmit() {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                });
            },
            reset() {
                this.submitted = false;
                this.po        = {
                    partner: null,
                    express_id: null,
                    currency_id: null,
                    contract_number: null,
                    contract_id: null,
                    audit: null,
                    rows: [
                        {
                            good: null,
                            quantity: null,
                            unit: {},
                            rate: null,
                            tax: null
                        }
                    ]
                }
            },
            setContract() {
                this.po.contract_number = null;
            },
            setContractNo() {
                this.contract       = null;
                this.po.contract_id = null;
            }
        }
    }
</script>

<style scoped>
    .form-group .required .control-label:after {
        content: "*";
        color: red;
    }
</style>
